export default "/images/9af0dac462d5ee9dc275fcb69571bbe3.avif";